import { useState, type JSX, type ReactNode } from 'react';

export function Panel({
  title,
  children,
  defaultOpen = true,
  right,
}: {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
  right?: ReactNode;
}): JSX.Element {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className="panel">
      <button className="panel-head" onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        <span>{title}</span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {right}
          <span className="faint">{open ? '−' : '+'}</span>
        </span>
      </button>
      {open ? <div className="panel-body">{children}</div> : null}
    </section>
  );
}

export function Row({
  label,
  value,
  title,
  tone,
}: {
  label: ReactNode;
  value: ReactNode;
  title?: string;
  tone?: 'ok' | 'warn' | 'err' | 'dim';
}): JSX.Element {
  return (
    <div className="row" title={title}>
      <span className="k">{label}</span>
      <span className={`v ${tone ?? ''}`}>{value}</span>
    </div>
  );
}

export function Field({
  label,
  children,
  title,
}: {
  label: ReactNode;
  children: ReactNode;
  title?: string;
}): JSX.Element {
  return (
    <label className="row" title={title}>
      <span className="k">{label}</span>
      <span className="v">{children}</span>
    </label>
  );
}
